
import fluent_svc from '../fluent-svc';
import { firstValueFrom } from 'rxjs';
import nm_svc from '../newsmax-svc';
import docket from '../docket-no-svc';
import { localstorage_wrapper } from './localstorage_svc';

async function do_fluent_postback() {
    const rs = await firstValueFrom(fluent_svc.set_pixel(), { defaultValue: { text: async () => '' } });
    if (rs) {
        const data = {
            fluent_response: await rs.text(),
            fluentClickId: fluent_svc.click_id,
            docketNo: docket.docket_no
        };
        if (data.fluent_response) {
            await firstValueFrom(nm_svc.save_state('nmFluentResponse', data), { defaultValue: true });
        }
        return rs;
    }
}

function send_purchase_event() {

    return new Promise((resolve, reject) => {
        try {
            const cleeng_data = localstorage_wrapper.get_cleeng_storage_data();
            window.gtag("event", "purchase", {
                docket: docket.docket_no,
                cleeng_offer_id: cleeng_data.cleeng_offer_id,
                cleeng_order_id: cleeng_data.cleeng_order_id,
                cleeng_customer_id: cleeng_data.cleeng_customer_id
            });
            resolve(true);
            return;
        }
        catch (error) {
            console.log("Could not send purchase event to GA4: ", error);
        }
        resolve(false)
    });
}

async function post_checkout() {
    try {
        await Promise.all([
            do_fluent_postback(),
            send_purchase_event(),
            firstValueFrom(nm_svc.set_user_external_data(), { defaultValue: true })
        ]);
    }
    catch (ex) {
        const data = {
            post_checkout_failed: ex,
            fluentClickId: fluent_svc.click_id,
            docketNo: docket.docket_no
        };
        console.error(data);
        await firstValueFrom(nm_svc.save_state('nmPostCheckoutFailed', data), { defaultValue: true });
    }
}

async function save_shipping_address(shippingAddressPayload) {

    try {

        await firstValueFrom(nm_svc.save_state('nmShippingAddress', { ...shippingAddressPayload, fluentClickId: fluent_svc.click_id }), { defaultValue: true });

    } catch (ex) {
        const data = {
            save_shippingaddress_failed: ex,
            fluentClickId: fluent_svc.click_id,
            docketNo: docket.docket_no
        };
        console.error(data);
        await firstValueFrom(nm_svc.save_state('nmShippingAddressFailed', data), { defaultValue: true });
    }
}

function get_order_id() {

    try {
        const cleeng_data = localstorage_wrapper.get_cleeng_storage_data();
        return cleeng_data && cleeng_data.cleeng_order_id ? cleeng_data.cleeng_order_id : '';
    } catch (e) {
        console.error(e)
    }
    return '';

}

export default { post_checkout, do_fluent_postback, save_shipping_address, get_order_id }